import { styled } from '@mui/material/styles';
import { TableCursorPaginationV2 } from '@components/TableV2/TableCursorPaginationV2';
import { useI18n } from '@hooks/useI18n/useI18n';
import { BankAccountReconciliationsTable } from '../bankAccountReconciliationsStyles';
import { useGetPendingAllocationsTableConfig } from './useGetPendingAllocationsTableConfig';

interface IStylesProps {
  numColumns: number;
}

export const PendingAllocationsTable = styled('div', {
  shouldForwardProp: prop => prop !== 'numColumns',
})<IStylesProps>(({ numColumns }) => ({
  '& td, & th': {
    maxWidth: `calc(100% / ${numColumns})`,
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  },
}));

export const PendingAllocations = () => {
  const { translate } = useI18n();

  const {
    columns,
    data: pendingAllocationsData,
    error,
    filtersSettings,
    isLoading,
    paginationSettings,
    sortingSettings,
  } = useGetPendingAllocationsTableConfig({ translate });

  return (
    <BankAccountReconciliationsTable>
      <PendingAllocationsTable numColumns={columns.length}>
        <TableCursorPaginationV2
          columns={columns}
          count={pendingAllocationsData?.count ?? 10}
          data={pendingAllocationsData?.results ?? []}
          error={error}
          filterSettings={filtersSettings}
          isLoading={isLoading}
          name="PendingAllocations"
          paginationSettings={paginationSettings}
          sortingSettings={sortingSettings}
          title={translate(
            'OPS_PORTAL.LABEL.BANK_ACCOUNT_RECONCILIATIONS.PENDING_ALLOCATIONS',
          )}
        />
      </PendingAllocationsTable>
    </BankAccountReconciliationsTable>
  );
};
